import gql from "graphql-tag";

const SUB_FORM_SUBMISSION = gql`
    subscription formSubmission($customer_type_id: Int!){
        formSubmission(customer_type_id: $customer_type_id)
    }
`;

export default SUB_FORM_SUBMISSION;
